import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    minWidth: 0,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderColor: theme.palette.border.card
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    minWidth: 0
  },
  title: {
    flex: 1,
    minWidth: 0,
    overflowWrap: 'anywhere'
  },
  actions: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    // DESIGN.md §9: touch devices (including tablets) get ~44px targets;
    // mouse-driven layouts keep the documented density.
    '@media (hover: none) and (pointer: coarse)': {
      '& button': { minWidth: 44, minHeight: 44 }
    }
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    minWidth: 0,
    overflowWrap: 'anywhere'
  },
  label: {
    color: theme.palette.text.light
  },
  groups: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(1.5),
    paddingTop: theme.spacing(1.5),
    borderTop: `1px solid ${theme.palette.border.card}`
  },
  group: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    minWidth: 0
  },
  groupTitle: {
    color: theme.palette.text.primary
  },
  footer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(1.5),
    paddingTop: theme.spacing(1.5),
    borderTop: `1px solid ${theme.palette.border.card}`
  }
}));
